export default "__VITE_ASSET__CxsOOld3__"